import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const ChangePassword: React.FC = () => {
  const { user, resetPassword } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (form.newPassword !== form.confirmPassword) {
      setError('Nowe hasła nie są identyczne');
      return;
    }

    if (form.newPassword.length < 12) {
      setError('Nowe hasło musi mieć minimum 12 znaków');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(user!.username, form.oldPassword, form.newPassword);
      setSuccess('Hasło zostało zmienione');
      setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => navigate('/machines'), 1500);
    } catch (e: any) {
      // Pokaż konkretny komunikat z backendu (np. za krótkie hasło / złe stare hasło).
      setError(e?.response?.data?.message || 'Nie udało się zmienić hasła. Sprawdź stare hasło.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '2rem auto' }}>
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1 className="auth-title">Zmiana hasła</h1>

        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-success">{success}</div>}

        <div className="form-group">
          <label className="form-label">Aktualne hasło</label>
          <input className="form-input" type="password" name="oldPassword" value={form.oldPassword} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label className="form-label">Nowe hasło (min. 12 znaków)</label>
          <input className="form-input" type="password" name="newPassword" value={form.newPassword} onChange={handleChange} required minLength={12} />
        </div>

        <div className="form-group">
          <label className="form-label">Potwierdź nowe hasło</label>
          <input className="form-input" type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} required />
        </div>

        <button className="btn btn-primary auth-btn" type="submit" disabled={loading}>
          {loading ? 'Zmieniam...' : 'Zmień hasło'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
